import { Button } from './ui/button';
import { useI18n } from '@/lib/i18n';

interface TatemaeModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAccept: () => void;
    onSelfEdit: () => void;
    data: {
        original: string;
        converted: string;
        reason: string;
        advice: string;
    } | null;
}

export function TatemaeModal({ isOpen, onClose, onAccept, onSelfEdit, data }: TatemaeModalProps) {
    const { t } = useI18n();
    if (!isOpen || !data) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                <div className="bg-[#800020] px-6 py-4 flex justify-between items-center">
                    <h3 className="text-xl font-bold text-white tracking-widest">TATEMAE MODE</h3>
                    <button onClick={onClose} className="text-white/80 hover:text-white text-2xl">&times;</button>
                </div>

                <div className="p-6 space-y-6">
                    <div className="text-center space-y-2">
                        <p className="text-lg font-medium text-gray-900">{t('あなたの感情が改善されました。')}</p>
                        <p className="text-sm text-gray-500">Your emotions have been improved.</p>
                    </div>

                    <div className="bg-[#fff0f0] p-4 rounded-lg border border-[#800020]/20 space-y-4">
                        <div>
                            <div className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">Original Text (Sentenced)</div>
                            <div className="text-gray-700 custom-strike decoration-[#800020] decoration-2 opacity-70">
                                {data.original}
                            </div>
                        </div>

                        <div className="border-t border-[#800020]/10 pt-4">
                            <div className="text-xs font-bold text-[#800020] uppercase tracking-wider mb-1 flex items-center gap-2">
                                <span>✨ Revised Text (Approved)</span>
                            </div>
                            <div className="text-lg font-medium text-gray-900 bg-white p-3 rounded border border-[#800020]/10 shadow-sm">
                                {data.converted}
                            </div>
                        </div>
                    </div>

                    <div className="bg-gray-50 p-4 rounded-lg space-y-2 text-sm">
                        <div className="flex gap-2">
                            <span className="font-bold text-[#800020] whitespace-nowrap">{t('検閲理由')}:</span>
                            <span className="text-gray-600">{data.reason}</span>
                        </div>
                        <div className="flex gap-2">
                            <span className="font-bold text-[#800020] whitespace-nowrap">{t('アドバイス')}:</span>
                            <span className="text-gray-600">{data.advice}</span>
                        </div>
                    </div>

                    <div className="flex justify-center gap-4 pt-2">
                        <Button
                            onClick={onAccept}
                            className="bg-[#800020] hover:bg-[#600018] text-white px-8 py-6 text-lg"
                        >
                            {t('承認して投稿')}
                        </Button>
                        <Button
                            variant="outline"
                            onClick={onSelfEdit}
                            className="px-6 py-6 text-gray-600"
                        >
                            {t('自分で書き直す')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
